/** 直建 Token 配额方式：总量 vs 输入/输出（互斥） */
export type DirectTokenQuotaMode = 'total' | 'io';

function hasPositiveNumber(value: unknown) {
  const num = Number(value);
  return Number.isFinite(num) && num > 0;
}

/**
 * 根据已填配额倒推直建 Token 配额方式。
 * 无有效配额时返回 undefined，避免空值把用户手动切换的模式冲掉。
 */
export function resolveDirectTokenQuotaMode(params: {
  billingTotalTokens?: unknown;
  inputTokens?: unknown;
  outputTokens?: unknown;
}): DirectTokenQuotaMode | undefined {
  if (hasPositiveNumber(params.billingTotalTokens)) return 'total';
  if (hasPositiveNumber(params.inputTokens) || hasPositiveNumber(params.outputTokens)) return 'io';
  return undefined;
}
